import { Trans } from '@lingui/macro'
import { Grid, Icon } from '@mui/material'
import Button from '@mui/material/Button'
import CardActions from '@mui/material/CardActions'
import Collapse from '@mui/material/Collapse'
import IconButton from '@mui/material/IconButton'
import Paper from '@mui/material/Paper'
import Typography from '@mui/material/Typography'
import { makeStyles } from '@mui/styles'
import { TextFieldWithFormik } from 'app/views/common-components/with-formik/TextFieldWithFormik'
import classnames from 'classnames'
import { useLayoutEffect, useState } from 'react'

const useStyles = makeStyles(theme => ({
  root: {
    [theme.breakpoints.up('sm')]: {
      minWidth: '344px !important'
    }
  },
  card: {
    backgroundColor: '#fddc6c',
    width: '100%'
  },
  typography: {
    fontWeight: 'bold'
  },
  actionRoot: {
    padding: '8px 8px 8px 16px'
  },
  icons: {
    marginLeft: 'auto'
  },
  expand: {
    transform: 'rotate(180deg)',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest
    })
  },
  expandOpen: {
    transform: 'rotate(90deg)'
  },
  collapse: {
    padding: 16
  },
  checkIcon: {
    fontSize: 20,
    color: '#b3b3b3',
    paddingRight: 4
  },
  button: {
    padding: 0,
    textTransform: 'none'
  }
}))

const AllocationComitteQuestionsCard = ({
  handleComment,
  disabled,
  handleSaveComment,
  handleSaveQuestion,
  editable,
  canVote,
  user,
  canAddComments,
  userName,
  index,
  id,
  description,
  comments = []
}) => {
  const classes = useStyles()
  const [expanded, setExpanded] = useState(true)
  const [questionAdded, setQuestionAdded] = useState(!editable)

  const handleExpandClick = () => {
    setExpanded(!expanded)
  }

  return (
    <div style={{ width: 'auto', marginLeft: 30, marginRight: 30 }}>
      <Paper square variant='outlined'>
        <CardActions
          style={{
            display: 'flex',
            justifyContent: 'flex-end'
          }}
        >
          <div
            style={{
              flexGrow: 6,
              width: '300px',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'flex-start',
              overflowWrap: 'break-word'
            }}
          >
            <Typography
              variant='subtitle2'
              align='left'
              style={{ fontSize: 10, wordBreak: 'break-word' }}
            >
              {userName}
            </Typography>

            {editable
              ? (
                <Grid container justifyContent='flex-start' alignItems='center'>
                  <TextFieldWithFormik
                    align='left'
                    placeholder='Add new question'
                    name={`questions.${[index]}.description`}
                    variant='outlined'
                    disabled={questionAdded}
                    fullWidth
                  />
                </Grid>
                )
              : (
                <Typography
                  variant='subtitle2'
                  align='left'
                  style={{ overflowWrap: 'break-word' }}
                >
                  {description}
                </Typography>
                )}
          </div>
          <div
            style={{
              minWidth: 215,
              display: 'flex',
              justifyContent: 'flex-end',
              alignItems: 'center'
            }}
          >
            {!editable
              ? (
                  canVote || canAddComments
                    ? (
                      <Button
                        variant='contained'
                        color='primary'
                        disabled={disabled}
                        onClick={() => {
                          setExpanded(true)
                          handleComment()
                        }}
                      >
                        <Typography>
                          <Trans>Add comment</Trans>
                        </Typography>
                      </Button>)
                    : <span />
                )
              : (
                <Button
                  style={{ marginLeft: 5 }}
                  variant='contained'
                  color='primary'
                  disabled={questionAdded}
                  onClick={e => {
                    setQuestionAdded(true)
                    handleSaveQuestion(index).then(
                      result => {

                      },
                      reject => {
                        setQuestionAdded(false)
                      }
                    )
                  }}
                >
                  <Trans>Save</Trans>
                </Button>
                )}
            <Grid
              style={{ width: '70px', marginLeft: 20 }}
              container
              direction='row'
              justifyContent='center'
              alignItems='center'
            >
              <Typography style={{ fontSize: 24 }}>
                {comments.length}
              </Typography>
              <IconButton
                aria-label='Show more'
                edge='start'
                onClick={handleExpandClick}
                className={classnames(classes.expand, {
                  [classes.expandOpen]: expanded
                })}
                size='large'
              >
                <Icon style={{ fontSize: 36 }}>play_arrow</Icon>
              </IconButton>
            </Grid>
          </div>
        </CardActions>
      </Paper>
      <Collapse in={expanded} timeout='auto' unmountOnExit>
        {comments.map((commentObj, cIndex) => {
          return (
            <CommentCard
              {...commentObj}
              cIndex={cIndex}
              handleSaveComment={handleSaveComment}
              key={commentObj.id || commentObj.tempId || `${index}-${cIndex}`}
              index={index}
            />
          )
        })}
      </Collapse>
    </div>
  )
}

const CommentCard = ({
  comment,
  createdBy,
  editable,
  cIndex,
  handleSaveComment,
  index
}) => {
  const [added, setAdded] = useState(!editable)

  return (
    <div
      align='left'
      key={cIndex}
      style={{
        width: 'auto',
        marginLeft: 50
      }}
    >
      <Paper variant='outlined' square style={{ padding: 5 }}>
        <Typography align='left' style={{ fontSize: 10 }}>
          {createdBy?.name}
        </Typography>

        {!editable
          ? (
            <div style={{ width: '100%' }}>
              <Typography
                gutterBottom
                align='left'
                style={{ padding: 5, wordWrap: 'break-word' }}
              >
                {comment}
              </Typography>
            </div>
            )
          : (
            <Grid container gap='16px' wrap='nowrap' alignItems='center'>
              <Grid item xs>
                <TextFieldWithFormik
                  placeholder='Add new comment'
                  name={`questions.${[index]}.comments.${[cIndex]}.comment`}
                  variant='outlined'
                  disabled={added}
                  fullWidth
                />
              </Grid>
              <Grid item>
                <Button
                  style={{ margin: 5 }}
                  variant='contained'
                  color='primary'
                  disabled={added}
                  onClick={e => {
                    setAdded(true)
                    handleSaveComment(index, cIndex).then(
                      result => {},
                      reject => {
                        setAdded(false)
                      }
                    )
                  }}
                >
                  <Trans>Save</Trans>
                </Button>
              </Grid>
            </Grid>
            )}
      </Paper>
    </div>
  )
}

export default AllocationComitteQuestionsCard
